export default __webpack_public_path__ + "static/media/ibm.26a48b8e.svg";